// Port of api/fuel/app/classes/filter/search/games/filters/post/game/count.php
import { rangeActive } from 'offline/filter/core/search/unit'
import Helpers from 'offline/filter/core/helpers'

export default {
	name: 'post.game.count',
	priority: 53,
	post: true,
	require: function(config, filter) {
		return (rangeActive(filter.count && filter.count.recommended, 1, 10)) || (rangeActive(filter.count && filter.count.best, 1, 10))
	},
	run: function(config, filter, data, results) {
		if (!results.meta || !results.meta.pc) return results
		var filteredIds = []
		for (var i = 0; i < results.index.length; i++) {
			var id = results.index[i]
			var whitelistId = results.games && results.mapIndex ? results.mapIndex[id] : id
			if (filter.count && filter.count.whitelist && filter.count.whitelist.indexOf(whitelistId) !== -1) {
				filteredIds.push(id)
				continue
			}
			if (filter.games && filter.games.include && filter.games.include.indexOf(whitelistId) !== -1) {
				filteredIds.push(id)
				continue
			}

			var raw = results.meta.pc[id]
			var metas = Array.isArray(raw) ? raw : [raw]

			for (var m = 0; m < metas.length; m++) {
				var poll
				try { poll = typeof metas[m] === 'string' ? JSON.parse(metas[m]) : metas[m] } catch (e) { poll = null }
				if (!poll) continue

				var pass = 0
				var requiredPass = 0

				if (rangeActive(filter.count.best, 1, 10)) {
					requiredPass++
					for (var count = filter.count.best.from; count <= filter.count.best.to; count++) {
						var best = poll[count]
						if (best && best.b > best.r + best.n) {
							pass++
							break
						}
					}
				}

				if (rangeActive(filter.count.recommended, 1, 10)) {
					requiredPass++
					for (var rc = filter.count.recommended.from; rc <= filter.count.recommended.to; rc++) {
						var rec = poll[rc]
						if (rec && (rec.b + rec.r) > rec.n) {
							if (filter.threshold && filter.threshold.notrecommended > 0) {
								var total = rec.b + rec.r + rec.n
								var percent = total ? (100 / total) * rec.n : 0
								if (percent <= filter.threshold.notrecommended) {
									pass++
									break
								}
							} else {
								pass++
								break
							}
						}
					}
				}

				if (pass === requiredPass) {
					filteredIds.push(id)
					break
				}
			}
		}
		results.index = Helpers.preserve_sort(results.index, filteredIds.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
		return results
	}
}
